module.exports = __webpack_public_path__ + "img/an.76b771ef.svg";